import { Table } from 'antd';
import { IProduct } from 'interface/product.interface';
import formatCurrencyVND from 'utils/formatCurrencyVND';

interface IProps {
  product?: IProduct;
}

export default function BomInfo(props: IProps): JSX.Element {
  const { product } = props;

  const columns = [
    {
      title: 'Component',
      dataIndex: 'idnrk',
      with: 200,
    },
    {
      title: 'Miêu tả sản phẩm',
      dataIndex: 'maktx',
      with: 400,
    },
    {
      title: 'Mã sản phẩm',
      dataIndex: 'matnr',
      with: 200,
    },
    {
      title: 'Đơn vị tính',
      dataIndex: 'meins',
      with: 200,
    },
    {
      title: 'Quantity',
      dataIndex: 'menge',
      with: 200,
    },
    {
      title: 'Plant',
      dataIndex: 'plant',
      with: 200,
    },
    {
      title: 'Component',
      dataIndex: 'postp',
      with: 200,
    },
    {
      title: 'BOM Usg',
      dataIndex: 'stlan',
      with: 200,
    },
    {
      title: 'Đơn vị tính - text',
      dataIndex: 'unit_stext',
      with: 200,
    },
  ];
  return (
    <>
      <Table
        rowKey={(record) => record.id}
        size="small"
        className="customTable"
        columns={columns}
        dataSource={product?.bom_info ? product?.bom_info : []}
        pagination={false}
        scroll={{ x: 1200 }}
      />
    </>
  );
}
